import React, { useEffect, useState } from "react";
import { Download, Eye, FileText } from "lucide-react";

function GRDownloadModal({ GRDownloadVisible, setGRDownloadVisible }) {
  const [documents, setDocuments] = useState([]);
  console.log("GRDownloadVisible:::::",GRDownloadVisible)
  // Function to remove timestamp prefix
  const getCleanFileName = (title) => {
    if (!title) return '';
    
    // Remove timestamp prefix like "1767944148467_"
    let cleaned = title.replace(/^\d+_/, '');
    
    // Remove file extension (everything after last dot)
    cleaned = cleaned.replace(/\.[^/.]+$/, '');
    
    return cleaned;
  };

  // Function to format date like "11th March, 2024"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      
      // Get day with ordinal suffix
      const day = date.getDate();
      const dayWithSuffix = day + (day % 10 === 1 && day !== 11 ? 'st' :
                                 day % 10 === 2 && day !== 12 ? 'nd' :
                                 day % 10 === 3 && day !== 13 ? 'rd' : 'th');
      
      // Month names
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      
      return `${dayWithSuffix} ${month}, ${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const parseDocuments = (grDocument) => {
    try {
      // If grDocument is already an array, return it directly
      if (Array.isArray(grDocument)) {
        return grDocument.sort((a, b) => {
          const dateA = new Date(a.grDate || 0);
          const dateB = new Date(b.grDate || 0);
          return dateB - dateA; // Descending order
        });
      }
      
      // If grDocument is a string, try to parse it as JSON
      if (typeof grDocument === 'string' && grDocument.trim()) {
        const parsed = JSON.parse(grDocument);
        
        // Ensure it's an array
        const docsArray = Array.isArray(parsed) ? parsed : [parsed];
        
        // Sort by date in descending order (newest first)
        return docsArray.sort((a, b) => {
          const dateA = new Date(a.grDate || 0);
          const dateB = new Date(b.grDate || 0);
          return dateB - dateA;
        });
      }
      
      // If grDocument is a single object, wrap it in an array
      if (grDocument && typeof grDocument === 'object') {
        return [grDocument].sort((a, b) => {
          const dateA = new Date(a.grDate || 0);
          const dateB = new Date(b.grDate || 0);
          return dateB - dateA;
        });
      }
      
      return [];
    } catch (error) {
      console.error("Error parsing grDocument:", error);
      return [];
    }
  };

  useEffect(() => {
    if (GRDownloadVisible?.schemeGr) {
      const parsedDocs = parseDocuments(GRDownloadVisible.schemeGr);
      setDocuments(parsedDocs);
    }
  }, [GRDownloadVisible]);

  const handleClose = () => {
    setGRDownloadVisible({ show: false, schemeGr: '' });
  };

  const handleView = (contentUrl) => {
    if (contentUrl) {
      // Remove any download parameter for viewing
      let viewUrl = contentUrl;
      
      if (viewUrl.includes('download=')) {
        // Remove download parameter (both true and false)
        viewUrl = viewUrl.replace(/[?&]download=(true|false)/, '');
        
        // Clean up URL if needed
        viewUrl = viewUrl.replace(/\?&/, '?');
        
        // Remove trailing '?' if exists
        if (viewUrl.endsWith('?')) {
          viewUrl = viewUrl.slice(0, -1);
        }
      }
      
      const fullUrl = viewUrl.startsWith('http') ? viewUrl : `${window.location.origin}${viewUrl}`;
      window.open(fullUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleDownload = (contentUrl) => {
    if (contentUrl) {
      let downloadUrl = contentUrl;
      
      // Fix URL format issues
      // 1. If URL contains &download= without ?, replace first & with ?
      if (downloadUrl.includes('&download=') && !downloadUrl.includes('?')) {
        downloadUrl = downloadUrl.replace('&download=', '?download=');
      }
      // 2. If URL doesn't have download parameter at all, add it
      else if (!downloadUrl.includes('download=')) {
        const separator = downloadUrl.includes('?') ? '&' : '?';
        downloadUrl = `${downloadUrl}${separator}download=true`;
      }
      // 3. If URL has download=false, change to true
      else if (downloadUrl.includes('download=false')) {
        downloadUrl = downloadUrl.replace('download=false', 'download=true');
      }
      
      const fullUrl = downloadUrl.startsWith('http') ? downloadUrl : `${window.location.origin}${downloadUrl}`;
      
      // Create anchor tag for download
      const link = document.createElement('a');
      link.href = fullUrl;
      
      // Extract filename from URL (clean version)
      const urlParts = fullUrl.split('/');
      let filename = urlParts[urlParts.length - 1].split('?')[0];
      
      // Remove timestamp prefix if exists
      filename = filename.replace(/^\d+_/, '');
      
      // Set download attribute with proper filename
      link.download = filename || 'document.pdf';
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  if (!GRDownloadVisible.show) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1" aria-modal="true" role="dialog">
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "900px", width: "100%" }}>
          <div className="modal-content shadow-lg border-0 rounded-4 overflow-hidden">
            <div
              className="modal-header text-white"
              style={{
                background: "#0f3b82",
                padding: "1.2rem 1.5rem",
              }}
            >
              <h4 className="modal-title fw-bold">
                <span className="me-2 d-inline-flex align-items-center">
                  <FileText size={18} />
                </span>
                Government Resolution Documents
              </h4>
              <button
                type="button"
                className="btn p-0 border-0 bg-transparent text-white"
                onClick={handleClose}
                aria-label="Close"
                style={{
                  fontSize: "28px",
                  lineHeight: 1,
                  width: "40px",
                  height: "40px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body p-4" style={{ background: "#f8f9fc" }}>
              {documents.length > 0 ? (
                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                  {/* Documents Table */}
                  <div className="mb-4">
                    <h6 className="fw-bold text-secondary text-uppercase mb-3">GR Documents</h6>
                    <div className="table-responsive">
                      <table className="table table-hover bg-white rounded-3 overflow-hidden shadow-sm">
                        <thead className="table-light">
                          <tr>
                            <th scope="col" className="ps-4" style={{ width: '50px' }}>S.No</th>
                            <th scope="col" style={{ width: '300px' }}>File Name</th>
                            <th scope="col" style={{ width: '200px' }}>Date</th>
                            <th scope="col" className="text-center" style={{ width: '150px' }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {documents.map((doc, index) => {
                            const cleanFileName = getCleanFileName(doc.title || doc.displayTitle);
                            const formattedDate = formatDate(doc.grDate);
                            
                            return (
                              <tr key={doc.documentId || index} className="align-middle">
                                <td className="ps-4 fw-semibold">{index + 1}</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <span className="text-primary me-2 d-inline-flex align-items-center">
                                      <FileText size={18} />
                                    </span>
                                    <div className="d-flex flex-column" style={{ maxWidth: '250px' }}>
                                      <span
                                        className="text-break"
                                        style={{
                                          lineHeight: '1.4',
                                          wordWrap: 'break-word',
                                          whiteSpace: 'normal'
                                        }}
                                        title={cleanFileName || `Document ${index + 1}`}
                                      >
                                        {cleanFileName || `Document ${index + 1}`}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <span className="text-muted fw-semibold">
                                    {formattedDate || "No date"}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <div className="d-flex justify-content-center gap-2">
                                    <button
                                      className="btn btn-sm rounded-pill px-3 d-inline-flex align-items-center justify-content-center"
                                      onClick={() => handleView(doc.contentUrl)}
                                      title="View Document"
                                      style={{
                                        background: "#0f3b82",
                                        borderColor: "#0f3b82",
                                        color: "#ffffff",
                                        minWidth: 64,
                                      }}
                                    >
                                      <Eye size={16} />
                                    </button>
                                    <button
                                      className="btn btn-sm rounded-pill px-3 ml-2 d-inline-flex align-items-center justify-content-center"
                                      onClick={() => handleDownload(doc.contentUrl)}
                                      title="Download Document"
                                      style={{
                                        background: "#0f3b82",
                                        borderColor: "#0f3b82",
                                        color: "#ffffff",
                                        minWidth: 64,
                                      }}
                                    >
                                      <Download size={16} />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5">
                  <div className="text-muted d-inline-flex align-items-center justify-content-center">
                    <FileText size={36} />
                  </div>
                  <h5 className="mt-3 text-muted">No documents available</h5>
                  <p className="text-muted">There are no documents attached to this scheme.</p>
                </div>
              )}
            </div>

            <div className="modal-footer border-0 p-3 bg-light justify-content-end">
              <button
                type="button"
                className="btn btn-outline-secondary rounded-pill px-4 kyb-icon-btn"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GRDownloadModal;